import OverviewCardHeader from "../Overview/OverviewCardHeader";
import OverviewEmptyState from "../Overview/OverviewEmptyState";
import { User, Users } from "lucide-react";
import { Card, CardContent } from "../../ui/card";
import { RiskyUserData } from "../interfaces/CommonInterfaces";

export default function OverviewRiskyUsers({
  riskyUsers,
  loading,
  fromdetails = false,
}: {
  riskyUsers: RiskyUserData[];
  loading: boolean;
  fromdetails?: boolean;
}) {
  const sortedRiskyUsers = [...riskyUsers].sort(
    (a, b) => b.alertCount - a.alertCount,
  );

  // Skeleton loader for a user item
  const renderSkeletonItem = (key: number) => (
    <div
      key={key}
      className="flex items-center justify-between p-2 border rounded-md bg-background/50 animate-pulse"
    >
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 bg-gray-300 rounded-full" />
        <div className="w-24 h-4 bg-gray-300 rounded" />
      </div>
      <div className="space-y-1 text-right">
        <div className="w-6 h-4 mx-auto bg-gray-300 rounded" />
        <div className="w-10 h-3 mx-auto bg-gray-300 rounded" />
      </div>
    </div>
  );

  return (
    <Card className="overview-card analytics-risk-card">
      <OverviewCardHeader
        fromdetails={fromdetails}
        title="Risky Users"
        description="Users ranked by alert volume"
        icon={Users}
      />
      <CardContent className="overview-card-content">
        <div className="analytics-risk-list space-y-3">
          {loading && [...Array(5)].map((_, idx) => renderSkeletonItem(idx))}

          {!loading &&
            riskyUsers.length === 0 &&
            (fromdetails ? (
              <OverviewEmptyState
                icon={Users}
                message="No risky users found."
              />
            ) : (
              <div className="py-8 text-sm text-center text-muted-foreground">
                No risky users found.
              </div>
            ))}

          {!loading &&
            riskyUsers.length > 0 &&
            sortedRiskyUsers.map((user) => (
              <div
                key={user.id}
                className="analytics-risk-row flex items-center justify-between p-2 border rounded-md bg-background/50 hover-elevate"
              >
                <div className="flex items-center gap-2">
                  <User className="w-4 h-4 text-muted-foreground" />
                  <span className="text-sm font-medium">{user.username}</span>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium">{user.alertCount}</div>
                  <div className="text-xs text-muted-foreground">
                    {user.percentage}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </CardContent>
    </Card>
  );
}
